<template>
  <div>
    <div
      @click="swiperSlideTo(0)"
      v-show="!swiper.isBeginning"
      id="last"
      style="display: flex; position: absolute; left: 0; top: 0; z-index: 2; height: 90px; width: 50px "
    >
      <div class="grad-last">
        <img src="@/assets/ntk_timeline_last.svg" id="arrow-last">
      </div>
    </div>
    <swiper class="slider" :options="swiperOption" ref="timeLineSwiper">
      <swiper-slide class="start">
        <div class="line-start"></div>
      </swiper-slide>
      <swiper-slide class="slide" v-for="(year, n) in years" :key="n">
        <div class="year" :class="{selected: $route.params.year == year.date}">
          <div>{{year.date}}</div>
        </div>
        <div class="con">
          <div
            class="dot"
            @click="selectCountry(year)"
            :style="{'background-color': yearColors[n]}"
          ></div>
          <div class="line"></div>
        </div>
      </swiper-slide>
      <swiper-slide class="end">
        <img src="@/assets/ntk_timeline_end.svg" class="arrow-end">
      </swiper-slide>
    </swiper>
    <div
      v-show="!swiper.isEnd"
      @click="swiperSlideTo(swiper.slides.length)"
      id="first"
      style="display: flex; position: absolute; right: 0; top: 0; z-index: 2; height: 90px; width: 50px "
    >
      <div class="grad-first">
        <img src="@/assets/ntk_timeline_first.svg" id="arrow-first">
      </div>
    </div>
  </div>
</template>

<script>
import YearsMixin from "../mixins/YearsMixin";
import CountriesMixin from "../mixins/CountriesMixin";
import _ from "lodash";

export default {
  name: "TimeLine",
  mixins: [YearsMixin, CountriesMixin],
  data() {
    return {
      swiper: {},
      yearColors: [],
      swiperOption: {
        mousewheel: true,
        freeMode: true,
        slidesPerView: "auto",
        resistance: true,
        resistanceRatio: 0,
        requestTimeout: {}
      }
    };
  },
  methods: {
    selectCountry(year) {
      const yearId = this.$route.params.year;
      // clearTimeout(this.requestTimeout);

      if (yearId != year.date) {
        // this.requestTimeout = setTimeout(() => {
        this.$router.push({
          path: `/index/${year.date}`
        });
        this.requestCountries();
        // }, 500);
      } else {
        this.$router.push({
          path: `/index`
        });
      }
    },
    createYearColors() {
      let i = 0;
      this.years.forEach(year => {
        let randomNumber = Math.floor(Math.random() * 8);
        if (
          i != 0 &&
          this.yearColors[i - 1] == this.yearsColorCodes[randomNumber]
        ) {
          do {
            randomNumber = Math.floor(Math.random() * 8);
          } while (
            this.yearColors[i - 1] == this.yearsColorCodes[randomNumber]
          );
        }
        this.yearColors.push(this.yearsColorCodes[randomNumber]);
        i++;
      });
    },
    swiperSlideTo(index) {
      this.swiper.slideTo(index);
    }
  },
  mounted() {
    this.swiper = this.$refs.timeLineSwiper.swiper;

    this.swiper.slides[0].style.width = "50px";
    this.swiper.slides[this.swiper.slides.length - 1].style.width = "50px";

    for (let i = 1; i < this.swiper.slides.length - 1; i++) {
      let yearDifference;
      if (i == this.swiper.slides.length - 2) {
        yearDifference = Math.abs(
          this.years[i - 1].date - new Date().getFullYear()
        );
      } else {
        yearDifference = Math.abs(this.years[i - 1].date - this.years[i].date);
      }
      this.swiper.slides[i].style.width = `${yearDifference * 0.8 + 50}px`;
    }

    // this.swiper.slideTo(
    //   _.findIndex(this.years, year => {
    //     return year == this.$route.params.year;
    //   }) - 1
    // );
  },
  created() {
    this.createYearColors();
    this.requestCountries();
  },
  destroyed() {
    // clearTimeout(this.requestTimeout);
  }
};
</script>

<style scoped>
.slider {
  display: flex;
  align-items: center;
  width: 100%;
  height: 90px;
  background-color: rgb(0, 0, 0);
}

.slide {
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  height: 90px;
  user-select: none;
}

.year {
  display: flex;
  align-items: center;
  margin-top: 15px;
  height: 30px;
  color: white;
  font-size: 14px;
  transform: translateX(-50%);
}

.con {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  width: 100%;
  height: 30px;
}

.dot {
  position: absolute;
  border: 10px solid rgb(0, 0, 0);
  border-radius: 20px;
  width: 10px;
  height: 10px;
  transform: translateX(-50%);
  transition: all 100ms ease-in-out;
  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
}
.dot:hover {
  width: 20px;
  height: 20px;
}

.line {
  flex: 1 1 auto;
  height: 4px;
  background-color: rgb(255, 255, 255);
}

.start,
.end {
  display: flex;
  position: relative;
  align-items: center;
  width: 50px;
  height: 90px;
}

.line-start {
  margin-top: 30px;
  width: 100%;
  height: 4px;
  background-color: rgb(255, 255, 255);
}

.arrow-end {
  width: 100%;
}

#arrow-last,
#arrow-first {
  width: 100%;
}
.grad-last {
  width: 50px;
  height: 90px;
  background: -moz-linear-gradient(
    left,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  background: -webkit-linear-gradient(
    left,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#000000', endColorstr='#00000000', GradientType=1);
}
.grad-first {
  width: 50px;
  height: 90px;
  background: -moz-linear-gradient(
    left,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  background: -webkit-linear-gradient(
    left,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00000000", endColorstr="#000000", GradientType=1);
}

.selected {
  font-weight: 900;
}
</style>